(function () {
  if (window.__customCardAddToCartBound) return;
  window.__customCardAddToCartBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-custom-add-to-cart');
    if (!button) return;
    if (button.disabled) return;

    // button.form resolves via the form="..." attribute, regardless of button type.
    var form = button.form;
    if (!form) {
      console.error('Add to cart button has no associated form.');
      return;
    }

    button.disabled = true;

    var cartDrawer = document.querySelector('cart-drawer-component');
    var itemsComponent = cartDrawer ? cartDrawer.querySelector('cart-items-component[data-section-id]') : null;
    var sectionId = itemsComponent ? itemsComponent.getAttribute('data-section-id') : null;

    var formData = new FormData(form);
    if (sectionId) {
      formData.append('sections', sectionId);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (addResult) {
        if (sectionId && addResult.sections && addResult.sections[sectionId] && itemsComponent) {
          var doc = new DOMParser().parseFromString(addResult.sections[sectionId], 'text/html');
          var newItemsComponent = doc.querySelector('cart-items-component[data-section-id="' + sectionId + '"]');
          var newStyle = doc.querySelector('style');
          if (newItemsComponent) {
            itemsComponent.replaceWith(newItemsComponent);
          }
          // Re-attach the section's scoped <style> tag if one was rendered,
          // so we don't lose the layout CSS this time.
          if (newStyle && !document.head.querySelector('style[data-section-id="' + sectionId + '"]')) {
            newStyle.setAttribute('data-section-id', sectionId);
            document.head.appendChild(newStyle);
          }
        }
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
      })
      .finally(function () {
        button.disabled = false;
      });
  });

  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    var dialog = cartDrawer.querySelector('dialog[ref="dialog"]') || cartDrawer.querySelector('dialog');
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    }
  }
})();
